export default {
  filterPlaceholder: 'Filtrovať podľa stavu',
  confirmDelete: 'Vymazanie stavu súboru "{filePathId}" nevymaže samotný súbor denníka. Ďalšie kolo zisťovania ho znova nájde a opätovne importuje. Pokračovať?',
  resetSelected: 'Resetovať vybrané ({count})',
  confirmBulkDelete: 'Vymazanie stavu {count} súborov denníka nevymaže samotné súbory denníka. Ďalšie kolo zisťovania ich znova nájde a opätovne importuje. Pokračovať?',
};
